var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZennSymbolLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88335 20.8675H6.73386C6.93771 20.8675 7.11891 20.7542 7.23216 20.5957L17.8324 3.17781C17.9683 2.95131 17.8097 2.6795 17.5379 2.6795H13.8913C13.7101 2.6795 13.5515 2.7701 13.4609 2.92865L2.70215 20.5504C2.6342 20.6863 2.7248 20.8675 2.88335 20.8675Z",
    fill: "#3EA8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1563 20.5957L21.1619 12.5549C21.3205 12.3057 21.1393 11.9886 20.8448 11.9886H17.2208C17.0849 11.9886 16.949 12.0566 16.8811 12.1698L11.7395 20.3918C11.6036 20.5957 11.7622 20.8675 12.0113 20.8675H15.7033C15.8845 20.8675 16.0657 20.7769 16.1563 20.5957Z",
    fill: "#3EA8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZennSymbolLogo);
export default __webpack_public_path__ + "static/media/icon_zenn_symbol_logo.5598c24ea8a5c90f1cd754ec5014af54.svg";
export { ForwardRef as ReactComponent };